import RestAPIClient from "services/RestAPIClient";
import { IStatisticConfig } from "components/base/Statistic/services/typings";

class MetricService extends RestAPIClient {
  constructor() {
    super("metrics");
  }

  getMetrics = async (
    kind: "campaign" | "campaign-onsite" | "creative"
  ): Promise<IStatisticConfig[]> => {
    const res = await this.get(`/${kind}`);
    return res.data;
  };
}

export default new MetricService();
